// Ported from design/project/App01-Splash.dc.html, then wired.
import { useEffect } from "react";
import { fit } from "../fit.js";
import { go } from "../router.js";

export function App01_Splash() {
  useEffect(() => {
    const t = setTimeout(() => go("App02", true), 1600);
    return () => clearTimeout(t);
  }, []);
  return (
    <>
      <div className="screen">
  <div className="htL" aria-hidden="true" style={{ position: "absolute", inset: "0", clipPath: "polygon(0 0, 100% 0, 100% 38%, 0 62%)" }}></div>
  <div className="htR" aria-hidden="true" style={{ position: "absolute", inset: "0", clipPath: "polygon(100% 38%, 100% 100%, 0 100%, 0 62%)" }}></div>
  <div aria-hidden="true" style={{ position: "absolute", inset: "0", background: "radial-gradient(circle at 50% 50%, rgba(11,14,20,0) 0%, rgba(11,14,20,0.85) 75%)" }}></div>
  <svg aria-hidden="true" width="390" height="844" viewBox="0 0 390 844" style={{ position: "absolute", left: "0", top: "0" }}>
    <line x1="0" y1="523" x2="390" y2="321" stroke="#FFFFFF" strokeWidth="3"></line>
  </svg>

  {/* Centred above the loading bar, and the logo gives way on short phones so the two never meet. */}
  <div style={{ position: "relative", height: "100%", boxSizing: "border-box", paddingBottom: "120px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
    <div style={{ position: "relative", width: "220px", height: fit(140, 200) }}>
      <svg width="96" height="120" viewBox="0 0 120 150" style={{ position: "absolute", left: "6px", top: "10px", height: fit(84, 120), width: "auto", transform: "rotate(-8deg)" }} aria-hidden="true">
        <path d="M60 4 L116 70 H82 V146 H38 V70 H4 Z" fill="#CCFF00" stroke="#0B0E14" strokeWidth="5" strokeLinejoin="round"></path>
      </svg>
      <svg width="96" height="120" viewBox="0 0 120 150" style={{ position: "absolute", right: "6px", top: fit(44, 64), height: fit(84, 120), width: "auto", transform: "rotate(8deg)" }} aria-hidden="true">
        <path d="M60 146 L116 80 H82 V4 H38 V80 H4 Z" fill="#FF3366" stroke="#0B0E14" strokeWidth="5" strokeLinejoin="round"></path>
      </svg>
      <svg width="70" height="94" viewBox="0 0 90 120" style={{ position: "absolute", left: "75px", top: fit(34, 50), height: fit(66, 94), width: "auto", animation: "ddBolt 0.8s infinite" }} role="img" aria-label="DegenDuel logo: two arrows split by a lightning bolt">
        <path d="M52 2 L10 66 H40 L28 118 L82 44 H50 Z" fill="#FFFFFF" stroke="#0B0E14" strokeWidth="4" strokeLinejoin="round"></path>
      </svg>
    </div>
    <div style={{ marginTop: "26px", transform: "skewX(-8deg)", textAlign: "center" }}>
      <div className="big" style={{ fontSize: fit(40, 50), color: "#CCFF00" }}>DEGEN</div>
      <div className="big" style={{ fontSize: fit(40, 50), color: "#FFFFFF" }}>DUEL</div>
    </div>
  </div>

  <div style={{ position: "absolute", left: "40px", right: "40px", bottom: "96px", display: "flex", flexDirection: "column", gap: "10px" }}>
    <div className="row"><span className="unb" style={{ fontWeight: "800", fontSize: "10px", letterSpacing: "0.16em" }}>LOADING ARENA</span><span className="mono lime" style={{ fontWeight: "800", fontSize: "11px" }}>72%</span></div>
    <div style={{ height: "14px", border: "2px solid #FFFFFF", borderRadius: "4px", background: "#161B22", transform: "skewX(-14deg)", overflow: "hidden" }}>
      <div style={{ width: "72%", height: "100%", background: "linear-gradient(180deg, #E6FF66, #CCFF00 50%, #9DC400)", animation: "ddLoad 2.4s ease-out infinite" }}></div>
    </div>
    <span className="muted" style={{ textAlign: "center", fontSize: "11px", marginTop: "4px" }}>Syncing price oracles</span>
  </div>
  <span className="unb muted" style={{ position: "absolute", left: "0", right: "0", bottom: "40px", textAlign: "center", fontWeight: "700", fontSize: "10px", letterSpacing: "0.2em" }}>SEASON 01</span>
</div>
    </>
  );
}
